"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlState = void 0;
const react_router_dom_1 = require("react-router-dom");
const useUrlState = (name) => {
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const state = searchParams.get(name) ?? "";
    const handleSetState = (value) => {
        if (!value)
            searchParams.delete(name);
        else
            searchParams.set(name, value);
        setSearchParams(searchParams);
    };
    return [
        state,
        handleSetState
    ];
};
exports.useUrlState = useUrlState;
